import { render } from "./NotificationSingleChoiceQuestionEditPane.vue?vue&type=template&id=b6cef364&ts=true"
import script from "./NotificationSingleChoiceQuestionEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationSingleChoiceQuestionEditPane.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__